import type { DocsLocale } from './types'

export interface DocsUiCopy {
  overview: string
  tutorial: string
  shortcuts: string
  glossary: string
  relatedPages: string
  previous: string
  next: string
}

export const DOCS_COPY_FIELDS = [
  'overview',
  'tutorial',
  'shortcuts',
  'glossary',
  'relatedPages',
  'previous',
  'next',
] as const satisfies readonly (keyof DocsUiCopy)[]

export const DOCS_COPY: Record<DocsLocale, DocsUiCopy> = {
  en: {
    overview: 'Overview',
    tutorial: 'Tutorial',
    shortcuts: 'Shortcuts',
    glossary: 'Glossary',
    relatedPages: 'Related pages',
    previous: 'Previous',
    next: 'Next',
  },
  ja: {
    overview: '概要',
    tutorial: 'チュートリアル',
    shortcuts: 'ショートカット',
    glossary: '用語集',
    relatedPages: '関連ページ',
    previous: '前へ',
    next: '次へ',
  },
  ar: {
    overview: 'نظرة عامة',
    tutorial: 'الدرس',
    shortcuts: 'الاختصارات',
    glossary: 'المصطلحات',
    relatedPages: 'صفحات ذات صلة',
    previous: 'السابق',
    next: 'التالي',
  },
  es: {
    overview: 'Resumen',
    tutorial: 'Tutorial',
    shortcuts: 'Atajos',
    glossary: 'Glosario',
    relatedPages: 'Páginas relacionadas',
    previous: 'Anterior',
    next: 'Siguiente',
  },
  ko: {
    overview: '개요',
    tutorial: '튜토리얼',
    shortcuts: '단축키',
    glossary: '용어집',
    relatedPages: '관련 페이지',
    previous: '이전',
    next: '다음',
  },
}
